import localizedCountries from 'app/features/products/localizedCountries.json';
import oneTierCRPlus from 'app/features/products/tiers/oneTierCR+';
import threeTiersUSCRPlus from 'app/features/products/tiers/threeTiersUSCR+';
import threeTiersROWCRPlus from 'app/features/products/tiers/threeTiersROWCR+';
import threeTiersLocalizedCRPlus from 'app/features/products/tiers/threeTiersLocalizedCR+';

const tierNameMap = {
  'International (1 tier) CR+': oneTierCRPlus,
  'US (3 tiers) CR+': threeTiersUSCRPlus,
  'International (3 tiers) - for CR localized countries CR+':
    threeTiersLocalizedCRPlus,
  'International (3 tiers) - for rest of the world CR+': threeTiersROWCRPlus,
};

const localizedCountriesMap = localizedCountries.reduce(
  (obj, countryCode) => ({ ...obj, [countryCode]: threeTiersLocalizedCRPlus }),
  {},
);

const countryCodeTierMap = {
  US: threeTiersUSCRPlus,
  ...localizedCountriesMap,
};

const regionByCurrencyMap = currency => {
  switch (currency) {
    case 'USD':
      return 'US ';
    case 'GBP':
      return 'UK ';
    case 'EUR':
      return 'EU ';
    default:
      return '';
  }
};

export { countryCodeTierMap, tierNameMap, regionByCurrencyMap };
